import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 特定商取引法に基づく表記 代表責任者
 */
export class SctActSupervisor extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SctActSupervisor {
    return new SctActSupervisor(value);
  }
}
